import { gql } from '@apollo/client';

const observationReportDocumentFragment = gql`
  fragment ObservationReportFields on ObservationReport {
    Id
    EventId
    ObservedUser {
      Id
      FullName
    }
    Result
    Document {
      Id
      Status
      FileName
      Comment
      ReviewerName
    }
  }
`;

export default observationReportDocumentFragment;
